import { useCallback } from "react";

/**
 * Creates a callback that toggles the provided state in the redux store
 *
 * @param toggleOn - A callback that toggles the state to on
 * @param toggleOff - A callback that toggles the state to off
 * @param toggled - Whether the state is toggled on or off
 */
export default function useToggle(toggleOn: () => void, toggleOff: () => void, toggled: boolean) {
  return useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    if (toggled) {
      toggleOff();
    } else {
      toggleOn();
    }
  }, [toggled, toggleOn, toggleOff]);
}
